import { useMutation } from '@tanstack/react-query';

import {
  useActiveWorkflowOrFail,
  useRootDocumentOrFail,
} from '../../../../hooks';
import { useEventHandler } from '../../../../hooks/useEventHandler';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getDocumentTransitions as fetchDocumentTransitions } from '../../requests/getDocumentTransitions';

export const useGetDocumentTransitions = () => {
  const rootDocument = useRootDocumentOrFail();
  const { workflow } = useActiveWorkflowOrFail();
  const { constructGet } = useRequestConstructor();

  const { mutateAsync } = useMutation({
    mutationFn: () =>
      fetchDocumentTransitions(
        constructGet,
        { definition: rootDocument.definition, workflow },
        rootDocument.id,
      ),
  });

  const getDocumentTransitions = useEventHandler(
    async (): Promise<string[]> => {
      const data = await mutateAsync();
      return data?.data.enabledTransitions ?? [];
    },
  );

  return { getDocumentTransitions };
};
